import * as React from "react"

import { cva } from "./cva.ts"

export const SelectControl = React.forwardRef<HTMLSelectElement, JSX.IntrinsicElements["select"]>(
  ({ className, ...props }, ref) => (
    <select className={classForSelectControl({ className })} ref={ref} {...props} />
  ),
)

export const classForSelectControl = cva([
  "flex w-stretch px-3 py-2 h-9 outline-none",
  "bg-background text-sm text-gray-12",
  "appearance-none",
  "bshadow rounded-md transition-all",
  "placeholder:text-gray-11",
  "autofill:bg-transparent",
  "disabled:cursor-not-allowed disabled:placeholder:text-gray-8",
  "focus-visible:ring-2",
])
